module.exports = __webpack_public_path__ + "prod/1.42.2/img/zfba.e78d492c.svg";